import { LeaveManagerApiDTO_LeaveApplication } from '../../Components/LeaveManager/LeaveApplicationForm'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'

const baseUrl = `${getBaseUrl()}API/v3/LeaveManager`
export const LeaveManager = createApi({
    reducerPath: 'LeaveManager',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        GetRequesters: builder.mutation<any, void>({
            query: () => ({
                url: 'Requesters',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        GetSettings: builder.mutation<any, void>({
            query: () => ({
                url: 'Settings',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        GetLeaveDetails: builder.mutation<any, number>({
            query: (requestId) => ({
                url: `${requestId}`,
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
        GetAvailability: builder.mutation<any, any>({
            query: (shiftsInput) => ({
                url: 'Availability',
                method: 'POST',
                body: APIHelper.prepareFormData(shiftsInput)
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : {}
            },
        }),
        CreateOrUpdateLeaveRequest: builder.mutation<any, any>({
            query: ({ type, requestId, leaveRequest }) => {
                if (type.toUpperCase() === 'PUT') {
                    return {
                        url: `${requestId}`,
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: leaveRequest,
                    }
                }
                return {
                    url: '',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: leaveRequest,
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : {}
            },
        }),
    }),
})

export const {
    useGetRequestersMutation,
    useGetSettingsMutation,
    useGetLeaveDetailsMutation,
    useGetAvailabilityMutation,
    useCreateOrUpdateLeaveRequestMutation,
} = LeaveManager
